import React from 'react';
import { Link } from 'react-router-dom';
import { defineMessages } from 'react-intl';
import BoxHistory from './BoxHistory';
import BoxActionInvite from './BoxActionInvite';
import BoxActionRemind from './BoxActionRemind';
import BoxActionSubmitted from './BoxActionSubmitted';

const i18n = defineMessages({
  notAvailable: {
    id: 'lbl.not_available',
    defaultMessage: 'Not Available',
  },
});

// TODO: We know if we are going to render an assessment/ survey / jps.
// TODO: We need to pass the proper data to each call
export const getTimelineHeader = (assessment, currentAccount, formatMessage) => {
  const notAvailable = formatMessage(i18n.notAvailable);
  const canDisplaySelfRespondentName =
    assessment &&
    assessment.template &&
    assessment.survey &&
    assessment.survey.self &&
    assessment.survey.self.respondent;

  const title = canDisplaySelfRespondentName
    ? `${assessment.template.title} - ${assessment.survey.self.respondent.firstName} ${assessment.survey.self.respondent.lastName}`
    : '-';

  switch (assessment.instrument) {
    case 'C360': {
      // we need to pass the survey id and the survey respondent id
      const url = `/accounts/${currentAccount}/surveys/${assessment.survey.id}`;
      return (
        <Link to={url} className="timeline-title">
          {title}
        </Link>
      );
    }
    case 'JPS': {
      if (assessment.jobProfile) {
        const template = assessment.jobProfile.assessmentTemplate.title;
        const url = `/accounts/${currentAccount}/jps/${assessment.id}`;
        return (
          <Link to={url} className="timeline-title">
            {template}
          </Link>
        );
      }
      return <p className="timeline-title">{notAvailable}</p>;
    }
    case 'STD': {
      const url = `/accounts/${currentAccount}/assessments/${assessment.id}`;
      return (
        <Link to={url} className="timeline-title">
          {assessment.template.title}
        </Link>
      );
    }
    default:
      return null;
  }
};

export const getTimelineHistory = (assessment) => ({
  NEW: <BoxHistory status="NEW" date={assessment.createdOn} />,
  INVITED: <BoxHistory status="INVITED" date={assessment.invitedOn} />,
  STARTED: <BoxHistory status="STARTED" date={assessment.startedOn} />,
  DECLINED: <BoxHistory status="DECLINED" date={assessment.declinedOn} />,
  EXPIRED: <BoxHistory status="EXPIRED" date={assessment.expiredOn} />,
  SUBMITTED: <BoxHistory status="SUBMITTED" assessment={assessment} date={assessment.submittedAt} />,
});

export const getTimelineAction = (
  lastAction,
  respondent,
  assessment,
  updateLastActionCallback,
  instrument,
  ownerUiPreferences,
  handlePreview,
  isPreview,
  availableTranslations,
) => {
  if (lastAction === 'NEW' && !respondent.anonymizedOn) {
    return (
      <BoxActionInvite
        assessment={assessment}
        respondent={respondent}
        updateLastAction={updateLastActionCallback}
        handlePreview={handlePreview}
        isPreview={isPreview}
      />
    );
  }

  if (lastAction === 'INVITED' && !respondent.anonymizedOn) {
    return (
      <BoxActionRemind
        assessment={assessment}
        respondent={respondent}
        updateLastAction={updateLastActionCallback}
        handlePreview={handlePreview}
        isPreview={isPreview}
      />
    );
  }

  if (lastAction === 'STARTED' && !respondent.anonymizedOn) {
    return (
      <BoxActionRemind
        assessment={assessment}
        respondent={respondent}
        updateLastAction={updateLastActionCallback}
        handlePreview={handlePreview}
        isPreview={isPreview}
      />
    );
  }

  if (lastAction === 'DECLINED' || lastAction === 'EXPIRED') {
    return null;
  }

  if (lastAction === 'SUBMITTED') {
    return (
      <BoxActionSubmitted
        assessment={assessment}
        respondent={respondent}
        instrument={instrument}
        ownerUiPreferences={ownerUiPreferences}
        availableTranslations={availableTranslations}
      />
    );
  }

  return null;
};

export default {
  getTimelineHeader,
  getTimelineHistory,
  getTimelineAction,
};
